import React from 'react';

import styles from './styles';

const {
    Label,
    Text,
    Link,
    Input,
    InputMocked,
    CheckboxError
} = styles;

class Checkbox extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            value: Boolean(props.value),
        };
    }

    handleChange = () => {
        const {
            onChange,
            name,
        } = this.props;

        const value = !this.state.value;
        this.setState({
            value,
        });
        onChange(name, value);
    };

    openModal = event => {
        event.preventDefault();
        const {
            name,
            onModalOpen,
        } = this.props;
        onModalOpen(name);
    }

    render() {
        const {
            name,
            label,
            link,
            value,
            errorOnAgreenment,
        } = this.props;

        return (
            <>
                <Label>
                    <Input
                        checked={value}
                        type="checkbox"
                        id={name}
                        name={name}
                        onChange={this.handleChange}
                    />
                    <InputMocked checked={this.state.value} errorOnAgreenment={errorOnAgreenment} />
                    <Text>{label} <Link href={link.href} onClick={this.openModal}>{link.text}</Link></Text>
                </Label>
                {errorOnAgreenment && <CheckboxError>Требуется согласиться с условиями использования сервиса</CheckboxError>}
            </>
        );
    }
}

export default Checkbox;
